import { render, staticRenderFns } from "./AbsensiSiswa.vue?vue&type=template&id=08cf8edc"
import script from "./AbsensiSiswa.vue?vue&type=script&lang=js"
export * from "./AbsensiSiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports